<div (click)="window.innerWidth <= mobileMaxWidth ? openMonthSelectorModal() : menuTrigger.openMenu()">
  <div #contentSlot>
    <ng-content></ng-content>
  </div>

  @if (!contentSlot.children.length) {
    <lla-selector-card label="Select Month" [value]="selectedMonthLabel()" [extraClasses]="extraClasses()"></lla-selector-card>
  }
</div>

<div
  [matMenuTriggerFor]="monthPickerMenu"
  #menuTrigger="matMenuTrigger"
  (menuOpened)="menuIsOpen.set(true)"
  (menuClosed)="onMenuClosed()"
></div>

<mat-menu
  #monthPickerMenu="matMenu"
  [hasBackdrop]="true"
  backdropClass="mg-menu-backdrop"
  class="lla-filter-menu-full"
>
  <div
    class="flex flex-col w-full md:w-[320px] p-base"
    (click)="$event.stopPropagation()"
    (keydown.Tab)="$event.stopPropagation()"
  >
    @if (menuIsOpen()) {
      <lla-month-selector
        #monthSelector
        [selectedMonth]="selectedMonth()"
        [includeFuture]="includeFuture()"
        (monthSelected)="onMonthSelected($event); menuTrigger.closeMenu()"
      ></lla-month-selector>
    }
  </div>
</mat-menu>
